import React, { useState } from 'react';
import { Input } from 'semantic-ui-react';

import { EyeToggleIcon } from './EyeToggleIcon';

import './css/index.css';

type Props = {
  dataTestId?: string;
  error?: boolean;
  id: string;
  label: string;
  placeholder?: string;
  value: string;
  strengthMeter?: (p: string) => number; // 0...4
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
};

export const PasswordField: React.FC<Props> = ({
  dataTestId = 'password-field',
  error = false,
  id,
  label,
  placeholder = '',
  value,
  strengthMeter,
  onChange,
  onBlur,
}) => {
  const [visible, setVisible] = useState(false);

  let withStrength = false;
  let strengthScore = 0;

  if (strengthMeter) {
    withStrength = true;
    strengthScore = strengthMeter(value);
  }

  return (
    <>
      <label htmlFor={id}>{label}</label>
      <Input
        autoComplete="new-password"
        data-test={dataTestId}
        error={error}
        id={id}
        placeholder={placeholder}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        icon={
          <EyeToggleIcon
            visible={visible}
            onClick={() => setVisible(!visible)}
          />
        }
      />
      {withStrength && (
        <>
          <span className="strength" data-score={strengthScore} />
          <div className="judgement">{strengthScore < 2 ? '　' : 'OK'}</div>
        </>
      )}
    </>
  );
};
